"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.errorContainerStyle = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'Montserrat, sans-serif'
        };
        _this.textStyles = {
            textAlign: 'center'
        };
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        // Update state to indicate an error occurred
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // Log the error and errorInfo or report it to an instrumentation endpoint
        var correlationId = (0, reportErrorsToInstrumentation_1.getCorrelationId)(this.props.featureId, this.props.widgetName);
        (0, reportErrorsToInstrumentation_1.default)({ error: error, errorInfo: errorInfo }, reportErrorsToInstrumentation_1.ErrorSourceType.WIDGET_RENDER_ERROR, correlationId);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            // render a fallback UI
            return (react_1.default.createElement("div", { style: this.errorContainerStyle },
                react_1.default.createElement("h3", { style: this.textStyles }, "Sorry, Something went wrong."),
                react_1.default.createElement("p", { style: this.textStyles },
                    "Correlation ID:",
                    ' ',
                    (0, reportErrorsToInstrumentation_1.getCorrelationId)(this.props.featureId, this.props.widgetName))));
        }
        // Render children as usual if no error occurred
        return react_1.default.createElement(react_1.default.Fragment, null, this.props.children);
    };
    return ErrorBoundary;
}(react_1.Component));
exports.default = ErrorBoundary;
